import React from 'react';
import InputField from '../components/InputField';
import styles from '../capitalExpenditure.module.scss';

const FourthQuarter = ({ 
  row, 
  viewMode, 
  handleInputChange, 
  handleOperationalRowChange, 
  isOperational = false 
}) => {
  const onChangeHandler = isOperational ? handleOperationalRowChange : handleInputChange;
  
  return (
    <>
      {/* Quarter 4 Columns */}
      <td className={styles.budgetCell}>
        <InputField
          value={row.q4BudgetDemand}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q4BudgetDemand', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q4AuthorityReceived}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q4AuthorityReceived', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q4Expense}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q4Expense', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q4Expense}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q4Expense', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q4RemainingBalance}
          placeholder="0"
          readOnly={true}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
    </>
  );
};

export default FourthQuarter;
